import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Fotter from "./Fotter";
import { Link } from "react-router-dom";
import SettingSidebar from "./SettingSidebar";
import Cookies from "js-cookie";
import { BASE_URL } from "../Pages/Config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CountdownTimer } from "./CountDownTimer";

import { faTrash } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Swal from "sweetalert2";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { formatDate } from "../components/dateUtils";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SettingWishlist() {
  const [bookmarks, setBookmarks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bookmarkCount, setBookmarkCount] = useState(0);

  const [openMenuId, setOpenMenuId] = useState(null);

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
  };

  const menuItemStyle = {
    padding: "10px 15px",
    cursor: "pointer",
    fontSize: "14px",
    borderBottom: "1px solid #f0f0f0",
  };

  const [showToast, setToastMessage] = useState("");
  const [setToastStatus] = useState(false);
  const user_id = Cookies.get("user_id");
  const username = Cookies.get("username");




  const [Reminderpopup, setReminderpopup] = useState(false)

  const [messageType, setMessageType] = useState("Whatsapp");

  const [itemid, setitemid] = useState("");
  const [duration, setDuration] = useState("3");

  const [reminderloader, setreminderloader] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);



  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2000,
  };

  const modalStyle = {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    width: "350px",
    maxWidth: "90%",
    textAlign: "center",
    position: "relative"
  };

  const buttonStyle = {
    width: '100%',
    padding: '6px 5px',
    fontWeight: 600,
    fontSize: '15px',
    borderRadius: '5px',
    background: '#ffca00',
  };

  const closeButtonStyle = {
    position: 'absolute',
    top: '-10px',
    right: '-10px',
    background: '#0082ff',
    color: 'white',
    fontWeight: 800,
    padding: '3px 10px',
    borderRadius: '30px',
    cursor: 'pointer', // optional, makes it look clickable
  };

  const fetchBookmarks = async () => {
    const user_id = Cookies.get("user_id");
    if (!user_id) {
      console.error("User ID not found in cookies.");

      setLoading(false);
      return;
    }

    try {
      const res = await fetch(
        `${BASE_URL}/all_fav_item.php?id=${user_id}&t=${Date.now()}`,
        {
          cache: "no-store",
        }
      );

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      console.log("Fetched data:", data);

      if (data.success) {
        setBookmarks(data.data);
        setBookmarkCount(data.data.length);
      } else {
        setBookmarks([]);
      }
    } catch (err) {
      console.error("Error fetching bookmarks:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookmarks();
  }, []);

  const removefav = async (id: string) => {
    if (!id || !user_id) {
      alert("Invalid id or type");
      return;
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't to remove from watchlist !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes ",
    });

    if (!result.isConfirmed) {
      return; // stop if user cancels
    }

    const response = {
      id,
      username,
      user_id,
    };

    // console.log(response);

    try {
      const res = await axios.post(
        `${BASE_URL}/add_favorite.php?type=remove`,
        response
      );

      // console.log(res);
      if (res.data.success) {
        toast.success("Removed from favorites !");
        // Refresh bookmarks list
        const updatedRes = await fetch(
          `${BASE_URL}/get_favorites.php?user_id=${user_id}&t=${Date.now()}`
        );
        const updatedData = await updatedRes.json();
        setBookmarks(updatedData.success ? updatedData.data : []);

        fetchBookmarks();
      } else {
        toast.danger("Try again !");
        setToastStatus(true);
        fetchBookmarks();
      }
    } catch (error) {
      console.error(error);
      toast.warning("Server error. Try again.");
    }
  };



  const [userreminders, setuserreminders] = useState([]);

  const fetchUserReminders = async () => {
    const user_id = Cookies.get("user_id");
    if (!user_id) return;

    try {
      const res = await fetch(
        `${BASE_URL}/user_reminders.php?user_id=${user_id}&t=${Date.now()}`,
        { cache: "no-store" },
      );

      const data = await res.json();
      // console.log("reminders:", data);

      if (data.success) {
        setuserreminders(data.data); // ✅ Correctly updates state
      } else {
        //  console.log("Error:", data.message);
        setuserreminders([]); // clear if no data
      }
    } catch (err) {
      console.error("Fetch failed:", err);
    }
  };

  useEffect(() => {
    fetchUserReminders(); // ✅ call function
  }, []);

  console.log(selectedItemId);

  const handleSetReminder = async (selectedItemId) => {
    try {
      setreminderloader(true);
      const formData = new FormData();
      const user_id = Cookies.get("user_id");
      formData.append("item_id", selectedItemId);
      formData.append("message_type", messageType || "Whatsapp");
      formData.append("duration", duration || "3");
      formData.append("user_id", user_id || "0");

      const response = await axios.post(
        `${BASE_URL}/set_reminder.php`,
        formData,
      );

      console.log(response);

      if (response.data.success) {

        setReminderpopup(false);


        toast.success("Reminder set successfully!");
        Swal.fire({
          title: "Reminder Set!",
          icon: "success",
          timer: 2000, // auto close after 2 seconds (2000 ms)
          showConfirmButton: false,
        });

        fetchBookmarks();
        fetchUserReminders();
        setreminderloader(false);

        window.location.reload();
      } else {
        fetchUserReminders();
        toast.error("Failed to set reminder.");
        setreminderloader(false);
      }
    } catch (error) {
      console.error("Error setting reminder:", error);
      toast.error("Failed to set reminder. Try again later!");
      setreminderloader(false);
    }
  };



  const stopReminder = async (itemId, index) => {
    // 🟡 Show confirmation alert
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to stop this reminder?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, stop it!",
      cancelButtonText: "Cancel",
    });

    // ❌ If user cancels
    if (!result.isConfirmed) {
      return;
    }

    try {

      const formData = new FormData();
      const user_id = Cookies.get("user_id");

      formData.append("item_id", itemId);
      formData.append("user_id", user_id || "0");
      formData.append("type", "stop");

      const response = await axios.post(
        `${BASE_URL}/set_reminder.php`,
        formData,
      );

      console.log(response);

      if (response.data.success) {
        toast.success("Reminder removed successfully!");
        Swal.fire({
          title: "Reminder Removed!",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });

        fetchBookmarks();
        fetchUserReminders();
        window.location.reload();

      } else {
        toast.error("Failed to remove reminder.");
      }
    } catch (error) {
      console.error("Error removing reminder:", error);
      toast.error("Failed to remove reminder. Try again later!");
    }
  };





  // console.log("data", bookmarks);
  return (
    <>
      <Navbar />

      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME </p>
                </Link>
                <span> /</span>
                <Link to="/">
                  <p>FASTTRADE</p>
                </Link>
                <span>/</span>

                <p>WISHLIST</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container">
          <div className="row">
            <SettingSidebar />
            <div className="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 ">
              <div className="col-12">
                <h2>
                  <b>Watch list {bookmarkCount} item</b>
                </h2>
              </div>
              <div
                className="setting-info"
                style={{ background: "transparent" }}
              >
                <div className="row g-4">
                  {loading ? (
                    <div
                      className="loading-overlay"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "550px",
                      }}
                    >
                      <div className="dot-spinner">
                        <div className="dot-spinner__dot"></div>
                        <div className="dot-spinner__dot"></div>
                        <div className="dot-spinner__dot"></div>
                        <div className="dot-spinner__dot"></div>
                        <div className="dot-spinner__dot"></div>
                        <div className="dot-spinner__dot"></div>
                        <div className="dot-spinner__dot"></div>
                        <div className="dot-spinner__dot"></div>
                      </div>
                    </div>
                  ) : bookmarks.length === 0 ? (
                    <>
                      <img
                        src={`${BASE_URL}/uploads/logo/data_not_found.png`}
                        alt="Example"
                        style={{
                          width: "100%",
                          height: "450px",
                          objectFit: "contain",
                          mixBlendMode: " darken",
                        }}
                      />
                    </>
                  ) : (
                    bookmarks.map((item, index) => (
                      <div
                        key={index}
                        className="col-xl-4 col-lg-4 col-md-6 p-0 wow animate fadeInDown"
                        data-wow-delay="200ms"
                        data-wow-duration="1500ms"
                      >
                        <div className="auction-card">
                          <div className="auction-card-img-wrap">
                            <Link
                              to={`/detail/${item.id}`}
                              className="card-img"
                            >
                              <img
                                src={
                                  item.photo
                                    ? `${BASE_URL}/${item.photo
                                      .split(",")[0]
                                      .trim()}`
                                    : `${BASE_URL}/uploads/logo/icon.png`
                                }
                                alt={item.title || "Auction Image"}
                                style={{ objectFit: "cover" }}
                              />
                            </Link>
                            <ul className="view-and-favorite-area" style={{ opacity: "15" }}>
                              <li style={{ position: "relative" }}>
                                <button
                                  onClick={() => toggleMenu(item.id)}
                                  style={{
                                    borderRadius: "50%",
                                    border: "none",
                                    background: "white",
                                    padding: "3px 13px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <FontAwesomeIcon icon={faEllipsisV} />
                                </button>

                                {openMenuId === item.id && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "40px",
                                      right: "0",
                                      background: "#fff",
                                      borderRadius: "8px",
                                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                      width: "170px",
                                      zIndex: 1000,
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        removefav(item.id);
                                        setOpenMenuId(null);
                                      }}
                                      style={menuItemStyle}
                                    >
                                      Remove Watchlist
                                    </div>


                                    {Array.isArray(userreminders) &&
                                      userreminders.some(
                                        (rem) => Number(rem.item_id) === Number(item.id),
                                      ) ? (
                                      <div
                                        onClick={() => {
                                          stopReminder(item.id);
                                          setOpenMenuId(null);
                                        }}
                                        style={menuItemStyle}
                                      >
                                        Stop Reminder
                                      </div>
                                    ) : (
                                      <div
                                        onClick={() => {
                                          setReminderpopup(true);
                                          setSelectedItemId(item.id)
                                          setOpenMenuId(null);
                                        }}
                                        style={menuItemStyle}
                                      >
                                        Set Reminder
                                      </div>
                                    )}


                                  </div>
                                )}
                              </li>
                            </ul>
                            <div>
                              <CountdownTimer closingTime={item.closing_time} />
                            </div>
                          </div>
                          <div className="auction-card-content">
                            <p style={{ fontSize: "12px" }}>
                              {formatDate(item.closing_time)}
                            </p>
                            <h6>
                              <Link to={`/detail/${item.id}`}>
                                {item.title}
                              </Link>
                            </h6>
                            <div className="details_buyer">
                              <h6>Item Id</h6> <p>#{item.id}</p>
                            </div>

                            <div className="details_buyer">
                              <h6>Current Bid</h6>{" "}
                              <p>{item.current_price} SAR</p>
                            </div>

                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {Reminderpopup && <>

        <div style={overlayStyle}   >


          <div style={modalStyle}
            className="whislist_massage"
          // style={{ display: "flex", gap: "10px" }}
          >
            <br />
            <p>
              <b>    Stay informed, and choose a time to be notified. Before
                Biding ends</b>
            </p>

            <div>
              <select
                className="form-control"
                style={{ marginBottom: "10px", marginTop: "10px" }}
                value={messageType}
                onChange={(e) => setMessageType(e.target.value)}
              >
                <option value="Whatsapp">
                  Send me Whatsapp message
                </option>
                <option value="Email">Send me Email message</option>
                <option value="SMS">Send me SMS message</option>
              </select>

              <select
                className="form-control"
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
              >
                <option value="3">3 hour</option>
                <option value="5">5 hour</option>
                <option value="7">7 hour</option>
              </select>
            </div>


            <button style={closeButtonStyle}
              onClick={() =>
                setReminderpopup(false)
              }
            >
              X
            </button>


            <div
              style={{
                display: "flex",
                gap: "5px",
                marginTop: "10px",
                fontSize: " clamp(10px, 13px, 20px)",
              }}
            >
              {reminderloader ? (
                <button style={buttonStyle}>
                  Proccesing......
                </button>
              ) : (
                <button
                  onClick={() =>
                    handleSetReminder(selectedItemId)
                  }
                  style={buttonStyle}
                >
                  Set Reminder
                </button>
              )}
            </div>
          </div>


        </div>

      </>}

      <Fotter />
    </>
  );
}


